'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootContent = exports.createChildView = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _vuSchemaProcessor = require('@ali/vu-schema-processor');

var _vuSchemaProcessor2 = _interopRequireDefault(_vuSchemaProcessor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var createChildView = exports.createChildView = function createChildView(_ref) {
  var _class, _temp;

  var _ref$name = _ref.name,
      name = _ref$name === undefined ? 'UnknownRootChildContainer' : _ref$name;
  return _temp = _class = function (_Component) {
    _inherits(RootChildContainer, _Component);

    function RootChildContainer() {
      _classCallCheck(this, RootChildContainer);

      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    RootChildContainer.prototype.render = function render() {
      return _react2.default.createElement(
        'div',
        { className: 'vc-' + name.toLocaleLowerCase() },
        this.props.children
      );
    };

    return RootChildContainer;
  }(_react.Component), _class.displayName = name, _class.propTypes = {
    children: _propTypes2.default.node
  }, _temp;
};

var RootContent = exports.RootContent = (_temp2 = _class2 = function (_Component2) {
  _inherits(RootContent, _Component2);

  function RootContent(props) {
    _classCallCheck(this, RootContent);

    var _this2 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this2.accessor = new _vuSchemaProcessor2.default(props.context);
    return _this2;
  }

  RootContent.prototype.render = function render() {
    var use1180 = this.accessor.getNavLayout() === '1180';
    var hasSideNav = this.accessor.hasSideNav();
    var rootStyle = {};
    if (this.props.rootContentPadding && this.props.rootContentPadding !== '0') {
      rootStyle.padding = this.props.rootContentPadding + 'px';
    }
    if (this.props.rootContentColor === 'white') {
      rootStyle.backgroundColor = 'white';
    }
    return _react2.default.createElement(
      'div',
      {
        className: 'vc-rootcontent',
        style: _extends({
          width: !hasSideNav && use1180 ? '1180px' : '100%'
        }, rootStyle)
      },
      this.props.children
    );
  };

  return RootContent;
}(_react.Component), _class2.displayName = 'RootContent', _class2.propTypes = {
  children: _propTypes2.default.node,
  context: _propTypes2.default.object,
  rootContentPadding: _propTypes2.default.string,
  rootContentColor: _propTypes2.default.string
}, _class2.defaultProps = {
  rootContentColor: 'white',
  rootContentPadding: ''
}, _temp2);